/**
 * Post state
 *
 * @export
 * @class AuthorizeState
 */
var AuthorizeState = /** @class */ (function () {
    function AuthorizeState() {
        /**
         * Authorized user identifier
         *
         * @type {number}
         * @memberof AuthorizeState
         */
        this.uid = 0;
        /**
         * If user is authed {true} or not {false}
         *
         * @type {Boolean}
         * @memberof AuthorizeState
         */
        this.authed = false;
        /**
         * If user is verifide {true} or not {false}
         *
         * @type {Boolean}
         * @memberof AuthorizeState
         */
        this.isVerifide = false;
        /**
         * If user password is updated {true} or not {false}
         *
         * @type {Boolean}
         * @memberof AuthorizeState
         */
        this.updatePassword = false;
        /**
         * If the user is guest {true} or not {false}
         *
         * @type {Boolean}
         * @memberof AuthorizeState
         */
        this.guest = false;
    }
    return AuthorizeState;
}());
export { AuthorizeState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/authorize/AuthorizeState.ts
// module id = 552
// module chunks = 50